module.exports = __webpack_public_path__ + "media/images/mailer/person-48-primary-270b718f7d38c65358132c97e171b5dd.png";